import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import { defineComponent, onBeforeUpdate, ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import draggable from "vuedraggable"; // modules

import POSConfigModule from "@/store/modules/pos-config";
import { PaymentMethodTypes } from "@/types/db/pos-config";
import { getLocale } from "@/lang";
import cloneDeep from "lodash/cloneDeep";
export default defineComponent({
  name: "SettingsPaymentMethods",
  components: {
    draggable: draggable
  },
  setup: function setup() {
    var _paymentConfig$invoic, _paymentConfig$invoic2, _paymentConfig$toBeIn, _paymentConfig$toBeIn2, _paymentConfig$bankTr, _paymentConfig$bankTr2, _paymentConfig$posRek, _paymentConfig$posRek2, _paymentConfig$divers, _paymentConfig$divers2, _paymentConfig$cheque, _paymentConfig$cheque2, _paymentConfig$cheque3, _paymentConfig$cheque4, _paymentConfig$cheque5, _paymentConfig$cheque6, _paymentConfig$passCu, _paymentConfig$passCu2, _paymentConfig$chorus, _paymentConfig$chorus2, _paymentConfig$CFF, _paymentConfig$CFF2, _paymentConfig$CGN, _paymentConfig$CGN2, _paymentConfig$QOQA, _paymentConfig$QOQA2, _paymentConfig$DEINDE, _paymentConfig$DEINDE2, _paymentConfig$REALDE, _paymentConfig$REALDE2, _paymentConfig$CE, _paymentConfig$CE2, _paymentConfig$OCCYG, _paymentConfig$OCCYG2, _paymentConfig$coupon, _paymentConfig$coupon2, _POSConfigModule$getP;

    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t;

    var paymentForms = ref([]);
    var drag = ref(false);
    var posConfig = POSConfigModule.selectedConfig;
    var groupId = computed(function () {
      return POSConfigModule.groupId;
    });
    var paymentConfig = (posConfig === null || posConfig === void 0 ? void 0 : posConfig.paymentConfig) || {
      cash: {
        used: true,
        acceptedCurrencies: ["CHF"]
      },
      cardAuto: {
        used: false,
        processor: "ADYEN"
      },
      cardManual: {
        used: true,
        paymentMethods: ["VISA", "TWINT"]
      },
      invoice: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      toBeInvoiced: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      bankTransfer: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      cheque: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      chequeVacances: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      chequeCulture: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      passCulture: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      chorus: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      CE: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      OCCYG: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      couponSport: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      posReka: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      diverseVoucher: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      terminal: "",
      CFF: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      CGN: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      QOQA: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      DEINDEAL: {
        used: false,
        acceptedStatuses: ["Pending"]
      },
      REALDEAL: {
        used: false,
        acceptedStatuses: ["Pending"]
      }
    }; // This is the default payment settigns array

    var settingsArray = [{
      id: PaymentMethodTypes.Cash,
      name: t("button.cash"),
      used: paymentConfig.cash.used,
      currency: paymentConfig.cash.acceptedCurrencies,
      terminal: null
    }, {
      id: PaymentMethodTypes.CardAuto,
      name: t("button.card"),
      used: paymentConfig.cardAuto.used,
      // currency: null,
      terminal: paymentConfig.terminal
    }, {
      id: PaymentMethodTypes.CardManual,
      name: "".concat(t("button.card"), " ").concat(t("button.manual-processing")),
      used: paymentConfig.cardManual.used,
      // currency: null,
      terminal: null,
      paymentMethods: paymentConfig.cardManual.paymentMethods
    }, {
      id: PaymentMethodTypes.Invoice,
      name: t("button.invoice"),
      used: (_paymentConfig$invoic = paymentConfig.invoice) === null || _paymentConfig$invoic === void 0 ? void 0 : _paymentConfig$invoic.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$invoic2 = paymentConfig.invoice) === null || _paymentConfig$invoic2 === void 0 ? void 0 : _paymentConfig$invoic2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.ToBeInvoiced,
      name: t("payment-method.TO_BE_INVOICED"),
      used: (_paymentConfig$toBeIn = paymentConfig.toBeInvoiced) === null || _paymentConfig$toBeIn === void 0 ? void 0 : _paymentConfig$toBeIn.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$toBeIn2 = paymentConfig.toBeInvoiced) === null || _paymentConfig$toBeIn2 === void 0 ? void 0 : _paymentConfig$toBeIn2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.BankTransfer,
      name: t("button.bank-transfer") + (groupId.value === 19329 ? "\n/ Bon cadeau (ancien)" : ""),
      used: (_paymentConfig$bankTr = paymentConfig.bankTransfer) === null || _paymentConfig$bankTr === void 0 ? void 0 : _paymentConfig$bankTr.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$bankTr2 = paymentConfig.bankTransfer) === null || _paymentConfig$bankTr2 === void 0 ? void 0 : _paymentConfig$bankTr2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.PosReka,
      name: t("payment-method.POS_REKA"),
      used: (_paymentConfig$posRek = paymentConfig.posReka) === null || _paymentConfig$posRek === void 0 ? void 0 : _paymentConfig$posRek.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$posRek2 = paymentConfig.posReka) === null || _paymentConfig$posRek2 === void 0 ? void 0 : _paymentConfig$posRek2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.DiverseVoucher,
      name: t("payment-method.POS_DIVERSE_VOUCHER"),
      used: (_paymentConfig$divers = paymentConfig.diverseVoucher) === null || _paymentConfig$divers === void 0 ? void 0 : _paymentConfig$divers.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$divers2 = paymentConfig.diverseVoucher) === null || _paymentConfig$divers2 === void 0 ? void 0 : _paymentConfig$divers2.acceptedStatuses
    }].concat(_toConsumableArray(POSConfigModule.getGroupCountryCode === "FR" || getLocale() === "fr" ? [{
      id: PaymentMethodTypes.Cheque,
      name: t("button.cheque"),
      used: (_paymentConfig$cheque = paymentConfig.cheque) === null || _paymentConfig$cheque === void 0 ? void 0 : _paymentConfig$cheque.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$cheque2 = paymentConfig.cheque) === null || _paymentConfig$cheque2 === void 0 ? void 0 : _paymentConfig$cheque2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.ChequeVacances,
      name: t("button.cheque-vacances"),
      used: (_paymentConfig$cheque3 = paymentConfig.chequeVacances) === null || _paymentConfig$cheque3 === void 0 ? void 0 : _paymentConfig$cheque3.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$cheque4 = paymentConfig.chequeVacances) === null || _paymentConfig$cheque4 === void 0 ? void 0 : _paymentConfig$cheque4.acceptedStatuses
    }, {
      id: PaymentMethodTypes.chequeCulture,
      name: t("button.cheque-culture"),
      used: (_paymentConfig$cheque5 = paymentConfig.chequeCulture) === null || _paymentConfig$cheque5 === void 0 ? void 0 : _paymentConfig$cheque5.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$cheque6 = paymentConfig.chequeCulture) === null || _paymentConfig$cheque6 === void 0 ? void 0 : _paymentConfig$cheque6.acceptedStatuses
    }, {
      id: PaymentMethodTypes.passCulture,
      name: t("button.pass-culture"),
      used: (_paymentConfig$passCu = paymentConfig.passCulture) === null || _paymentConfig$passCu === void 0 ? void 0 : _paymentConfig$passCu.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$passCu2 = paymentConfig.passCulture) === null || _paymentConfig$passCu2 === void 0 ? void 0 : _paymentConfig$passCu2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.chorus,
      name: t("button.chorus"),
      used: (_paymentConfig$chorus = paymentConfig.chorus) === null || _paymentConfig$chorus === void 0 ? void 0 : _paymentConfig$chorus.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$chorus2 = paymentConfig.chorus) === null || _paymentConfig$chorus2 === void 0 ? void 0 : _paymentConfig$chorus2.acceptedStatuses
    }] : []), _toConsumableArray(groupId.value && [1, 16342, 16383,
    /*Fort Chillion*/
    19657].includes(groupId.value) ? [{
      id: PaymentMethodTypes.CFF,
      name: t("payment-method.cff"),
      used: (_paymentConfig$CFF = paymentConfig.CFF) === null || _paymentConfig$CFF === void 0 ? void 0 : _paymentConfig$CFF.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$CFF2 = paymentConfig.CFF) === null || _paymentConfig$CFF2 === void 0 ? void 0 : _paymentConfig$CFF2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.CGN,
      name: t("payment-method.cgn"),
      used: (_paymentConfig$CGN = paymentConfig.CGN) === null || _paymentConfig$CGN === void 0 ? void 0 : _paymentConfig$CGN.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$CGN2 = paymentConfig.CGN) === null || _paymentConfig$CGN2 === void 0 ? void 0 : _paymentConfig$CGN2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.QOQA,
      name: t("payment-method.qoqa"),
      used: (_paymentConfig$QOQA = paymentConfig.QOQA) === null || _paymentConfig$QOQA === void 0 ? void 0 : _paymentConfig$QOQA.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$QOQA2 = paymentConfig.QOQA) === null || _paymentConfig$QOQA2 === void 0 ? void 0 : _paymentConfig$QOQA2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.DEINDEAL,
      name: t("payment-method.deindeal"),
      used: (_paymentConfig$DEINDE = paymentConfig.DEINDEAL) === null || _paymentConfig$DEINDE === void 0 ? void 0 : _paymentConfig$DEINDE.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$DEINDE2 = paymentConfig.DEINDEAL) === null || _paymentConfig$DEINDE2 === void 0 ? void 0 : _paymentConfig$DEINDE2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.REALDEAL,
      name: t("payment-method.realdeal"),
      used: (_paymentConfig$REALDE = paymentConfig.REALDEAL) === null || _paymentConfig$REALDE === void 0 ? void 0 : _paymentConfig$REALDE.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$REALDE2 = paymentConfig.REALDEAL) === null || _paymentConfig$REALDE2 === void 0 ? void 0 : _paymentConfig$REALDE2.acceptedStatuses
    }] : []), _toConsumableArray(groupId.value && [19360, 16342, 16383].includes(groupId.value) ? [{
      id: PaymentMethodTypes.CE,
      name: t("button.CE"),
      used: (_paymentConfig$CE = paymentConfig.CE) === null || _paymentConfig$CE === void 0 ? void 0 : _paymentConfig$CE.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$CE2 = paymentConfig.CE) === null || _paymentConfig$CE2 === void 0 ? void 0 : _paymentConfig$CE2.acceptedStatuses
    }, {
      id: PaymentMethodTypes.OCCYG,
      name: t("button.OCCYG"),
      used: (_paymentConfig$OCCYG = paymentConfig.OCCYG) === null || _paymentConfig$OCCYG === void 0 ? void 0 : _paymentConfig$OCCYG.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$OCCYG2 = paymentConfig.OCCYG) === null || _paymentConfig$OCCYG2 === void 0 ? void 0 : _paymentConfig$OCCYG2.acceptedStatuses
    }] : []), _toConsumableArray(groupId.value && [1, 16342
    /*DEV*/
    , 16383
    /*TEST*/
    , 19345
    /* Trampoline Spirit */
    ].includes(groupId.value) ? [{
      id: PaymentMethodTypes.CouponSport,
      name: t("button.coupon-sport"),
      used: (_paymentConfig$coupon = paymentConfig.couponSport) === null || _paymentConfig$coupon === void 0 ? void 0 : _paymentConfig$coupon.used,
      terminal: null,
      acceptedStatuses: (_paymentConfig$coupon2 = paymentConfig.couponSport) === null || _paymentConfig$coupon2 === void 0 ? void 0 : _paymentConfig$coupon2.acceptedStatuses
    }] : [])); // settingsArray
    // in case we added new payment methods, we should add them while keeping the order and settings of the user

    var newPaymentMethods = [];

    if (POSConfigModule.getPaymentSettings.length) {
      for (var i = 0; i < settingsArray.length; i++) {
        var exists = false;

        for (var j = 0; j < POSConfigModule.getPaymentSettings.length; j++) {
          if (settingsArray[i].id === POSConfigModule.getPaymentSettings[j].id) {
            exists = true;
            break;
          }
        }

        if (!exists) {
          newPaymentMethods.push(settingsArray[i]);
        }
      }
    }

    var settingsData = ref(cloneDeep((_POSConfigModule$getP = POSConfigModule.getPaymentSettings) !== null && _POSConfigModule$getP !== void 0 && _POSConfigModule$getP.length ? [].concat(_toConsumableArray(POSConfigModule.getPaymentSettings), newPaymentMethods) : settingsArray)); // get Adyen terminals

    POSConfigModule.fetchGroupInfo();
    onBeforeUpdate(function () {
      paymentForms.value = [];
    });
    return {
      paymentForms: paymentForms,
      settingsData: settingsData,
      drag: drag
    };
  }
});